import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

const MUTATION = gql`
  mutation UpdateLongFormBuilderOutlineSection(
    $id: ID!
    $name: String
    $headline: String!
    $content: String
    $contentMarkup: [ContentMarkupInput!]
    $assetType: AssetTypeEnum
    $manualKeywords: [String!]
    $instructions: String
    $generationLength: BlogOutlineSectionGenerationLengthEnum
    $mediaInfo: MediaInfoInput
  ) {
    updateLongFormBuilderOutlineSection(
      id: $id
      name: $name
      headline: $headline
      content: $content
      contentMarkup: $contentMarkup
      assetType: $assetType
      manualKeywords: $manualKeywords
      instructions: $instructions
      generationLength: $generationLength
      mediaInfo: $mediaInfo
    ) {
      ...LongFormSection
    }
  }
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;

export const updateLongFormBuilderOutlineSection = async ({
  id,
  name,
  content,
  contentMarkup,
  assetType,
  manualKeywords,
  instructedWriting,
  generationLength,
  mediaInfo,
}) => {
  const variables = {
    id,
    name,
    headline: '', // for backward compatibility, "headline" is not used in "long form" sections anymore,,
    content,
    contentMarkup,
    assetType,
    manualKeywords,
    instructions: instructedWriting,
    generationLength,
    mediaInfo,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(response.data);
};
